import { useState, useRef } from "react";
import classes from "./AutocompleteSearchBar.module.scss";
import { nodes } from "../data/nodes";

export default function AutocompleteSearchBar({ onSelect, armies = [] }) {
  const [inputValue, setInputValue] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const inputRef = useRef();

  const nodeOptions = nodes.map(node => ({
    type: "node",
    id: node.id,
    name: node.name,
    nodeType: node.type,
    eng: node.eng,
    position: node.position,
    raw: node
  }));
  const armyOptions = armies
    .filter(army => army.status !== "scout")
    .map(army => ({
      type: "army",
      id: army.id,
      name: army.name,
      node: army.node,
      raw: army
    }));
  const allOptions = [...nodeOptions, ...armyOptions];

  const filteredOptions = inputValue.trim() === ""
    ? []
    : allOptions
        .map(option => {
          if (option.type === "army") {
            const idMatch = option.id.toString().startsWith(inputValue);
            const nameMatch = option.name && option.name.toLowerCase().startsWith(inputValue.toLowerCase());
            const generalMatch = option.raw.general && option.raw.general.toLowerCase().startsWith(inputValue.toLowerCase());
            let matchingSoldier = null;
            const soldiersMatch = Array.isArray(option.raw.soldiers) && option.raw.soldiers.some(soldier => {
              if (soldier && soldier.toLowerCase().includes(inputValue.toLowerCase())) {
                matchingSoldier = soldier;
                return true;
              }
              return false;
            });
            if (generalMatch) {
              return { ...option, displayType: "general" };
            } else if (soldiersMatch) {
              return { ...option, displayType: "soldier", matchingSoldier };
            } else if (idMatch || nameMatch) {
              return { ...option, displayType: "army" };
            }
            return null;
          } else if (option.type === "node") {
            const idMatch = option.id.toString().startsWith(inputValue);
            const nameMatch = option.nodeType !== "mine" && option.name && option.name.toLowerCase().startsWith(inputValue.toLowerCase());
            const englishMatch = option.nodeType === "city" && option.eng && option.eng.toLowerCase().startsWith(inputValue.toLowerCase());
            if (idMatch || nameMatch || englishMatch) {
              return { ...option, displayType: "node" };
            }
            return null;
          }
          return null;
        })
        .filter(Boolean);

  const handleSelect = (option) => {
    let label;
    if (option.displayType === "general") {
      label = option.raw.general;
    } else if (option.displayType === "soldier") {
      label = option.matchingSoldier;
    } else if (option.displayType === "army") {
      label = option.name;
    } else if (option.displayType === "node") {
      label = option.name && option.nodeType !== "mine"
        ? option.name
        : option.id.toString();
    } else {
      label = option.id.toString();
    }
    setInputValue(label);
    setShowDropdown(false);
    if (onSelect) {
      if (option.type === "node") {
        onSelect(option.raw);
      } else if (option.type === "army") {
        // For armies, find the node and pass it to onSelect
        const node = nodes.find(n => n.id === option.node);
        if (node) onSelect(node);
      }
    }
  };

  return (
    <div
      className={classes.mapSearchBar}
      tabIndex={-1}
      style={{ position: "absolute" }}
    >
      <input
        ref={inputRef}
        type="text"
        placeholder="Search..."
        value={inputValue}
        onChange={e => {
          setInputValue(e.target.value);
          setShowDropdown(true);
        }}
        onFocus={e => {
          e.target.parentNode.classList.add('active');
          setShowDropdown(true);
        }}
        onBlur={e => {
          e.target.parentNode.classList.remove('active');
          setTimeout(() => setShowDropdown(false), 100);
        }}
        autoComplete="off"
      />
      {showDropdown && filteredOptions.length > 0 && (
        <ul className={classes.autocompleteDropdown}>
          {filteredOptions.map(option => (
            <li
              key={option.type + '-' + option.id + '-' + (option.displayType || '')}
              onMouseDown={() => handleSelect(option)}
            >
              {(() => {
                if (option.displayType === "general") {
                  return option.raw.general && `${option.raw.general} (General)`;
                } else if (option.displayType === "soldier") {
                  return option.matchingSoldier && `${option.matchingSoldier} (Soldier)`;
                } else if (option.displayType === "army") {
                  return option.name ? `${option.name} (Army)` : `Army`;
                } else if (option.displayType === "node") {
                  if (option.name && option.nodeType !== "mine") {
                    return `${option.name} (Node: ${option.id})`;
                  } else {
                    return `Node: ${option.id}`;
                  }
                } else {
                  return option.id.toString();
                }
              })()}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
